export default __webpack_public_path__ + "static/salary-data-mockup-cafae2d0c53e3b5981edd55fc83bf15b.png";